import React from "react";
import * as Icons from "lucide-react";
import { BadgeCheck } from "lucide-react";
import { media, icons, translations } from "../mock";
import { useLang } from "../i18n/LanguageContext";
import useReveal from "../hooks/useReveal";

export default function About() {
  const { ref, visible } = useReveal();
  const { lang } = useLang();
  const a = translations[lang].about;

  return (
    <section id="about" className="py-24 md:py-28">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div ref={ref} className={`grid lg:grid-cols-2 gap-14 items-center reveal ${visible ? "is-visible" : ""}`}>
          <div className="relative order-2 lg:order-1">
            <div className="rounded-[2rem] overflow-hidden device-shadow">
              <img src={media.aboutImage} alt="Healthcare in Qatar" className="w-full h-[420px] md:h-[480px] object-cover" />
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <span className="text-sm font-bold uppercase tracking-widest text-cblue">{a.eyebrow}</span>
            <h2 className="mt-3 font-display text-3xl md:text-4xl font-extrabold text-navy leading-tight">{a.title}</h2>
            {a.body.map((p, i) => (<p key={i} className="mt-5 text-slate-600 leading-relaxed">{p}</p>))}
            <div className="mt-6 flex items-start gap-3 rounded-2xl border border-cblue/20 bg-sky-tint p-4">
              <BadgeCheck className="h-6 w-6 shrink-0 text-cblue" />
              <p className="text-sm font-medium text-navy">{a.founder}</p>
            </div>
            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              {a.benefits.map((b, i) => {
                const Icon = Icons[icons.aboutBenefits[i]] || Icons.Check;
                return (
                  <div key={i} className="flex gap-3 rounded-2xl border border-slate-100 bg-white p-4 hover:shadow-md transition-shadow">
                    <div className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-sky-tint"><Icon className="h-5 w-5 text-cblue" /></div>
                    <div>
                      <p className="font-semibold text-navy text-[15px]">{b.title}</p>
                      <p className="text-sm text-slate-500 mt-0.5">{b.text}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
